// extracted by mini-css-extract-plugin
module.exports = {"button":"order_food_message_button__u_ZDI"};